import { MapPin } from "lucide-react";
import { GuardedLink } from "../../runtime/DevPlaceholder";
import type { LinkTarget } from "../../types";

export type EventItem = {
  tag: string;
  title: string;
  location: string;
  href: LinkTarget;
  startDay: number | string;
  endDay?: number | string;
  monthLabel: string; // e.g., "AOUT", "OCTOBRE"
};

/** Event card with date block, tag, title and location. */
export function EventCard({ tag, title, location, href, startDay, endDay, monthLabel }: EventItem) {
  return (
    <GuardedLink href={href} label={title} block className="group flex overflow-hidden bg-white">
      {/* Date block */}
      <div className="flex w-24 sm:w-28 shrink-0 flex-col items-center justify-center bg-[#0095DB] px-3 py-4 text-white">
        <div className="text-base xl:text-lg font-semibold leading-tight sm:text-lg">
          {startDay}{endDay ? " > " + endDay : ""}
        </div>
        <div className="text-[10px] uppercase tracking-wide sm:text-xs">{monthLabel}</div>
      </div>

      {/* Content */}
      <div className="flex min-h-[92px] flex-1 flex-col justify-center bg-slate-50 px-4 py-3">
        <div className="text-[10px] font-semibold uppercase tracking-wide text-[#0095DB]">{tag}</div>
        <div className="mt-1 line-clamp-2 text-sm xl:text-base font-medium leading-5 text-[#005CA9]">
          {title}
        </div>
        <div className="mt-2 flex items-center gap-2 text-xs xl:text-sm text-slate-600">
          <MapPin className="h-3.5 w-3.5 text-[#F9A21B]" />
          <span>{location}</span>
        </div>
      </div>
    </GuardedLink>
  );
}


